import TYPES from '@/types';

// Application
import CustomerOverviewService from '@/modules/home-dashboard/customer-overview/application/services/customer-overview-service';

// Domain
import CustomerOverviewState from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import Vue from 'vue';
import { Values } from '@/modules/shared/domain/i18n/types';

export default class ErrorKuspitAccountInProcessOfValidationViewModel {
  @Inject(TYPES.CUSTOMER_OVERVIEW_SERVICE)
  private readonly customer_overview_service!: CustomerOverviewService;

  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  readonly i18n_namespace = 'components.contract-savings.creating_account.kuspit.error';

  private readonly view!: Vue;

  customer_overview: CustomerOverviewState;

  public constructor(view: Vue) {
    this.view = view;
    this.customer_overview = this.customer_overview_service.get_customer_overview();
  }

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  accept = () => {
    this.view.$emit('cancelProcess');
  }
}
